<template>
  <v-app>   

    <v-main>
      <v-container class="fill-height container-background" fluid></v-container>
      <v-container 
            class="fill-height justify-center" 
            fluid
        >
           <v-row 
            class="text-center"
            style="z-index:10"
          >
              <v-col cols="12">
                <v-img
                  :src="require('./assets/logo.png')"
                  class="my-3"
                  contain
                  height="250"
                />
              </v-col>

              <v-col cols="12" class="mb-4">
                <h1 class="primary--text display-2 font-weight-bold mb-3">
                  Welcome to {{ schoolName }}
                </h1>

                <p class="display-1 font-weight-light primary--text">
                  Online Portal
                </p>  
              </v-col>

              <v-col cols="12">
                <h2 class="primary--text font-weight-light font-italic">
                  Select the link to get started
                </h2>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                  <v-btn
                    color="primary"
                    
                    large
                    href="https://ereports-barackporeeast.ttschoolnet2.com"                    
                  >Student E-Reports</v-btn>
              </v-col>

              <!-- <v-col
                cols="12"
                md="4"
              >
                  <v-btn
                    color="primary"                    
                    outlined
                    large
                    href="https://registration.dinsleytrincitygov.com" 
                  >Student Registration</v-btn>
              </v-col>  -->

              <v-col
                cols="12"
                md="6"
              >
                  <v-btn
                    color="secondary"
                    dark
                    large
                     href="https://app-barackporeeast.ttschoolnet2.com"                     
                  >
                    <span class="primary--text">Teachers Portal</span>
                  </v-btn>
              </v-col>  
           </v-row>
        </v-container>
      
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
    
  },

  data: () => ({
    schoolName: "Barrackpore East Secondary",
  }),
};
</script>

<style scoped>
    .container-background{
        /* background-image: url('./assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%); */
        position: absolute;        
    }
       
</style> 
